import React from "react";
import { useParams } from "react-router";
import CreateNewsletterContainer from "../../containers/newsletter/CreateNewsletter";

const CreateNewsletterPage = () => {
  const { id } = useParams();
  return id ? (
    <CreateNewsletterContainer newsletterId={id} />
  ) : (
    <CreateNewsletterContainer />
  );
};

export default CreateNewsletterPage;
